import { Placement } from 'api/placement/types'
import { graphql } from 'msw'
import db from '../db'

const placementHandlers = [
  graphql.query('listPlacements', (req, res, ctx) => {
    const placements = db.placement.getAll(
      (placement) => placement.application.id === req.variables.applicationId
    )
    return res(ctx.data({ placements }))
  }),

  graphql.query('queryPlacement', (req, res, ctx) => {
    const placement = db.placement.get(req.variables.id)
    return res(ctx.data({ placement }))
  }),

  graphql.mutation('createPlacement', (req, res, ctx) => {
    const { exchangeRate, applicationId, virtualCurrencyId, ...placementData } =
      req.variables

    const placement = db.placement.create({
      ...(placementData as Placement),
      application: { id: applicationId },
      virtualCurrency: { id: virtualCurrencyId },
    })

    return res(ctx.data({ placementCreate: { placement } }))
  }),

  graphql.mutation('updatePlacement', (req, res, ctx) => {
    const placement = db.placement.update({
      ...(req.variables as Placement),
      exchangeRates: req.variables.exchangeRates.filter(
        (rate) => rate._destroy !== true
      ),
    })

    const correctData = { placementUpdate: { placement } }

    const errorsAfterUnsuccessfulRequest = [
      { message: 'Error 1' },
      { message: 'Error 2' },
    ]

    const errorsAfterSuccessfulRequest = {
      errors: ["Field 'backgroundColor' doesn't exist on type 'Color'"],
    }

    if (placement.name === 'TestError') {
      return res(ctx.errors(errorsAfterUnsuccessfulRequest))
    }

    if (placement.name === 'TestErrorAfterSuccess') {
      return res(ctx.data({ errorsAfterSuccessfulRequest }))
    }

    return res(ctx.data(correctData))
  }),

  graphql.mutation('deletePlacement', (req, res, ctx) => {
    const placement = db.placement.remove(req.variables.id)
    return res(ctx.data({ placementDestroy: { placement } }))
  }),
]

export default placementHandlers
